module.exports = __webpack_public_path__ + "img/search-white.b4d3c005.svg";